<template>
  <div>
    <h2 class="car-name text-subtitle-2">
      <small class="mr-1">{{car.maker}}</small>
      <span class="mr-1">{{car.name}}</span>
    </h2>
    <v-row no-gutters align="center">
      <v-col cols="4">
        <v-img
          :src="car.images[0]"
          :aspect-ratio="4/3"
          contain
        />
      </v-col>
      <v-col cols="8" class="pl-4 text-caption">
        <div>{{carTypeName}}</div>
        <div class="mb-1">
          <span class="d-inline-block mr-1">{{displacementText}}</span>
          <span class="d-inline-block mr-1">{{fuelText}}</span>
          <span class="d-inline-block mr-1">/</span>
          <span class="d-inline-block mr-1">{{driveText}}</span>
          <span class="d-inline-block mr-1">/</span>
          <span class="d-inline-block mr-1">{{car.seat}}人乗り</span>
        </div>
        <div class="car-price">
          <span>{{car.dayprice | comma}} 円/日</span>&nbsp;
          <small>(税込)</small>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import * as C from '@/app/special/consts'

export default {
  name: 'DaysProfile',
  props: {
    car: {
      type: Object,
      required: true
    }
  },
  computed: {
    carTypeName () {
      const name = C.cartypeNames[this.car.type]
      return name || ''
    },
    missionText () {
      const item = this.car.specs.find(item => item.name === 'ギア')
      if (!item) {
        return 'AT'
      }
      return item.value
    },
    driveText () {
      const item = this.car.specs.find(item => item.name === '駆動')
      if (!item) {
        return '2WD'
      }
      return item.value
    },
    fuelText () {
      const item = this.car.specs.find(item => item.name === '燃料')
      if (!item) {
        return 'ガソリン'
      }
      return item.value
    },
    displacementText () {
      const item = this.car.specs.find(item => item.name === '排気量')
      if (!item) {
        return '-- L'
      }
      return (item.value / 1000) + 'L'
    }
  },
  filters: {
    comma (n) {
      return n.toLocaleString()
    },
    typename (type) {
      return C.cartypeNames[type] || ''
    },
    typecolor (type) {
      if (type === 'cab') {
        return 'blue'
      } else if (type === 'van') {
        return 'orange'
      } else {
        return 'green'
      }
    }
  }
}
</script>
